import config from "./config";

let ip = 'localhost'

export default {
    ...config,
    debug: true,
    ssl: false,
    directives: {
        connectSrc: [
            ip + ":30011", ip + ":30010", ip + ":30012"
        ],
        imgSrc: [
            "blob:", ip + ":30012", ip + ":30010", "*.tile.osm.org"
        ],
        fontSrc: [
            "data:"
        ]
    },
    urls: {
        api: ip + ':30011',
        cdn: ip + ':30012',
        site: ip + ':30015'
    },
    serverIp: ['127.0.0.1', '::1', ip],
    siteOrigin: ['http://' + ip + ':30015']
}
